import orderInstance from '../instance'

const addOrderProcessingTime = (orderId, data) => {
  return orderInstance.post('/orders/' + orderId + '/confirm', data)
}

export default addOrderProcessingTime
